<div class="flex-column gap flex-1 p-2">
    <app-date-input
        [form]="form"
        id="validFrom"
        timeType="startOfDay"
    ></app-date-input>

    <app-date-input
        [form]="form"
        id="validTo"
        timeType="endOfDay"
    ></app-date-input>
</div>

